import React from 'react';
import './ConfirmDialog.css';

// Small reusable confirmation modal for destructive actions (delete user,
// delete plant, etc.) - avoids relying on window.confirm() for a more
// consistent, styleable UX.
export default function ConfirmDialog({ open, title, message, confirmLabel = 'Confirmer', danger = true, onConfirm, onCancel }) {
  if (!open) return null;
  return (
    <div className="confirm-overlay" onClick={onCancel}>
      <div className="confirm-dialog" onClick={(e) => e.stopPropagation()}>
        <h3>{title}</h3>
        <p>{message}</p>
        <div className="confirm-actions">
          <button className="btn-secondary" onClick={onCancel}>Annuler</button>
          <button className={danger ? 'btn-danger' : 'btn-primary'} onClick={onConfirm}>{confirmLabel}</button>
        </div>
      </div>
    </div>
  );
}
